import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Phone, PhoneCall, Mail, MessageCircle, MessageSquare, ChevronRight, Send } from 'lucide-react';
import { cn } from '../../lib/utils';
import {
  PRIORITY_CONFIG, STATUS_CONFIG,
  formatRelativeTime, formatDateTime, isOverdue,
} from '../../utils/nurtureUtils';

const LeadCard = ({ lead, onSelect, onQuickAction }) => {
  const priority = PRIORITY_CONFIG[lead.priority] || PRIORITY_CONFIG.Warm;
  const status = STATUS_CONFIG[lead.status] || STATUS_CONFIG.new_lead;
  const PriorityIcon = priority.icon;
  
  // Map priority to border color classes
  const borderColorMap = {
    Hot: 'border-l-red-500',
    Warm: 'border-l-amber-400',
    Cold: 'border-l-blue-500'
  };
  const borderColor = borderColorMap[lead.priority] || 'border-l-slate-300';
  
  return (
    <Card 
      className={cn(
        "cursor-pointer hover:shadow-md transition-all border-l-4 bg-white dark:bg-slate-800 dark:border-slate-700",
        borderColor
      )}
      onClick={() => onSelect(lead)}
      data-testid={`lead-row-${lead.id}`}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-semibold text-slate-900">{lead.name}</h3>
              <Badge variant="outline" className={cn("text-xs", priority.textColor)}>
                <PriorityIcon className="w-3 h-3 mr-1" />
                {lead.priority}
              </Badge>
            </div>
            <p className="text-sm text-slate-500">{lead.lead_type} • {lead.lead_source}</p>
            <div className="flex items-center gap-4 mt-2 text-xs text-slate-400">
              {lead.phone && <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{lead.phone}</span>}
              {lead.email && <span className="flex items-center gap-1"><Mail className="w-3 h-3" />{lead.email}</span>}
            </div>
          </div>
          <div className="text-right">
            <Badge className={cn("text-xs", status.color)}>{status.label}</Badge>
            {lead.next_follow_up_at && (
              <p className={cn(
                "text-xs mt-1",
                isOverdue(lead.next_follow_up_at) ? "text-red-500 font-medium" : "text-slate-400"
              )}>
                {isOverdue(lead.next_follow_up_at) ? '⚠️ Overdue' : `Next: ${formatDateTime(lead.next_follow_up_at)}`}
              </p>
            )}
          </div>
        </div>
        
        {/* Quick Actions */}
        <div className="flex items-center gap-2 mt-3 pt-3 border-t" onClick={e => e.stopPropagation()}>
          <Button size="sm" variant="outline" className="flex-1" onClick={() => onQuickAction(lead, 'call')}>
            <PhoneCall className="w-4 h-4 mr-1" /> Call
          </Button>
          <Button size="sm" variant="outline" className="flex-1" onClick={() => onQuickAction(lead, 'sms')}>
            <MessageSquare className="w-4 h-4 mr-1" /> SMS
          </Button>
          <Button size="sm" variant="outline" className="flex-1" onClick={() => onQuickAction(lead, 'email')}>
            <Mail className="w-4 h-4 mr-1" /> Email
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export { LeadCard };
export default LeadCard;
